// extracted by mini-css-extract-plugin
export default {"layout":"layout___H_qYx"};